import * as React from 'react';
import { Box } from "@mui/system"
import { Button } from "@mui/material";
import { send_authorized_request } from '../Constants/cognito'
import { AXIOS_API_INSTANCE, SERVICE_ORDER_PART_STATUS_TYPES } from '../Constants';
import { useSnackbar } from 'notistack';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { MuiColorInput } from 'mui-color-input'
import {
    GridRowModes,
    DataGrid,
    GridToolbarContainer,
    GridActionsCellItem,
    GridRowEditStopReasons,
    GridEditInputCell,
} from '@mui/x-data-grid';
import { useTheme } from "@emotion/react"
import { sort_custom_statuses } from '../Utils/service';

function EditToolbar(props) {
    const { myServiceOrderPartsStatuses, setMyServiceOrderPartsStatuses, setRowModesModel, order_rows } = props;
    const theme = useTheme();

    const handleClick = () => {
        const updated_statuses = { ...myServiceOrderPartsStatuses, "<<NEWSTATUS>>": { id: "<<NEWSTATUS>>", name: '', alert_hours: 0, customer_communication: false, alert_tech: false, alert_manager: false, alert_writer: false, alert_part_specialist: false, type: 'IN_PROGRESS', custom_color: theme.palette.primary.main } }
        setMyServiceOrderPartsStatuses(updated_statuses);
        order_rows(updated_statuses)
        setTimeout(function () {
            setRowModesModel((oldModel) => ({
                ...oldModel,
                "<<NEWSTATUS>>": { mode: GridRowModes.Edit, fieldToFocus: 'name' },
            }));
        }, 100);
    };

    return (
        <GridToolbarContainer>
            <Button color="primary" startIcon={<AddIcon />} onClick={handleClick} disabled={Object.keys(setMyServiceOrderPartsStatuses).some((x) => { return setMyServiceOrderPartsStatuses[x].id === "<<NEWSTATUS>>" })} variant='outlined'>
                Add New Status
            </Button>
        </GridToolbarContainer>
    );
}

export default function ClientConfigurationPartsStatuses({ setClient, setIsLoading, service_order_parts_statuses }) {
    const { enqueueSnackbar } = useSnackbar()
    const [rowModesModel, setRowModesModel] = React.useState({});
    const [myServiceOrderPartsStatuses, setMyServiceOrderPartsStatuses] = React.useState({})
    const [sortedRows, setSortedRows] = React.useState([])

    const handleRowEditStop = (params, event) => {
        if (params.reason === GridRowEditStopReasons.rowFocusOut || params.reason === GridRowEditStopReasons.enterKeyDown) {
            event.defaultMuiPrevented = true;
        }
    };

    const handleEditClick = (id) => () => {
        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
    };

    const handleSaveClick = (id) => () => {
        setIsLoading(true)
        if (id === "<<NEWSTATUS>>") {
            const add_custom_service_status = {
                new_status: { ...myServiceOrderPartsStatuses[id] },
                new_status_name: myServiceOrderPartsStatuses[id].name
            }
            delete add_custom_service_status.new_status.id
            delete add_custom_service_status.new_status.name
            send_authorized_request(() =>
                AXIOS_API_INSTANCE.post(`client/add_custom_service_part_status`, add_custom_service_status).then(
                    (client) => {
                        enqueueSnackbar('Successfully added custom part status', { variant: 'success' })
                        console.log({ ...rowModesModel, [id]: { mode: GridRowModes.View }, [myServiceOrderPartsStatuses[id].name]: { mode: GridRowModes.View } })
                        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View }, [myServiceOrderPartsStatuses[id].name]: { mode: GridRowModes.View } });
                        setIsLoading(false)
                        setTimeout(function () {
                            setClient(client.data.data)
                        }, 100);
                    }
                ).catch((error) => {
                    setIsLoading(false)
                    enqueueSnackbar(`Failed to add custom part status <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error' })
                })
            )
        } else {
            const edit_custom_service_status = {
                old_status_name: id,
                new_status: { ...myServiceOrderPartsStatuses[id] },
                new_status_name: myServiceOrderPartsStatuses[id].name
            }
            delete edit_custom_service_status.new_status.id
            delete edit_custom_service_status.new_status.name
            send_authorized_request(() =>
                AXIOS_API_INSTANCE.post(`client/edit_custom_service_part_status`, edit_custom_service_status).then(
                    (client) => {
                        enqueueSnackbar('Successfully updated custom part status', { variant: 'success' })
                        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View }, [myServiceOrderPartsStatuses[id].name]: { mode: GridRowModes.View } });
                        setIsLoading(false)
                        setTimeout(function () {
                            setClient(client.data.data)
                        }, 100);
                    }
                ).catch((error) => {
                    setIsLoading(false)
                    enqueueSnackbar(`Failed to update custom part status <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error' })
                })
            )
        }
    };

    const handleDeleteClick = (id) => () => {
        if (window.confirm(`Are you sure you want to delete the part status ${myServiceOrderPartsStatuses[id].name}? This cannot be undone`)) {
            const remove_custom_service_status = {
                status_name: id
            }
            send_authorized_request(() =>
                AXIOS_API_INSTANCE.post(`client/remove_custom_service_part_status`, remove_custom_service_status).then(
                    (client) => {
                        enqueueSnackbar('Successfully deleted custom part status', { variant: 'success' })
                        setIsLoading(false)
                        setClient(client.data.data)
                    }
                ).catch((error) => {
                    setIsLoading(false)
                    enqueueSnackbar(`Failed to delete custom part status <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error' })
                })
            )

        }
    };

    const handleReorderClick = (id, direction) => () => {
        const reorder_custom_service_status = {
            status_name: id,
            direction: direction
        }
        send_authorized_request(() =>
            AXIOS_API_INSTANCE.post(`client/reorder_custom_service_part_status`, reorder_custom_service_status).then(
                (client) => {
                    enqueueSnackbar('Successfully updated custom part status', { variant: 'success' })
                    setIsLoading(false)
                    setClient(client.data.data)
                }
            ).catch((error) => {
                setIsLoading(false)
                enqueueSnackbar(`Failed to update custom part status <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error' })
            })
        )
    };

    const handleCancelClick = (id) => () => {
        setRowModesModel({
            ...rowModesModel,
            [id]: { mode: GridRowModes.View, ignoreModifications: false },
        })
        if (id === "<<NEWSTATUS>>") {
            setTimeout(function () {
                resetMyServiceOrderPartsStatuses()
            }, 100);
        } else {
            resetMyServiceOrderPartsStatuses()
        }
    };

    const processRowUpdate = (updatedRow) => {
        // const updatedmyServiceOrderPartsStatuses = { ...myServiceOrderPartsStatuses }
        // updatedmyServiceOrderPartsStatuses[updatedRow.id] = updatedRow
        // setMyServiceOrderPartsStatuses(updatedmyServiceOrderPartsStatuses);
        return updatedRow;
    };

    const handleRowModesModelChange = (newRowModesModel) => {
        console.log(newRowModesModel)
        // setRowModesModel(newRowModesModel);
    };

    const columns = [
        {
            field: 'name',
            headerName: 'Name',
            minWidth: 130,
            flex: 2,
            editable: true,
            sortable: false,
            filterable: false,
            valueSetter: (value, row) => {
                if (myServiceOrderPartsStatuses[row.id]?.name !== value && row.id) {
                    const updatedmyServiceOrderPartsStatuses = { ...myServiceOrderPartsStatuses }
                    updatedmyServiceOrderPartsStatuses[row.id].name = value
                    setMyServiceOrderPartsStatuses(updatedmyServiceOrderPartsStatuses);
                }
                return { ...row, name: value }
            }
        },
        {
            field: 'alert_hours',
            headerName: 'Alert Hours',
            type: 'number',
            minWidth: 80,
            flex: 1,
            align: 'left',
            headerAlign: 'left',
            editable: true,
            sortable: false,
            filterable: false,
            valueSetter: (value, row) => {
                if (myServiceOrderPartsStatuses[row.id]?.alert_hours !== value && row.id) {
                    const updatedmyServiceOrderPartsStatuses = { ...myServiceOrderPartsStatuses }
                    updatedmyServiceOrderPartsStatuses[row.id].alert_hours = value
                    setMyServiceOrderPartsStatuses(updatedmyServiceOrderPartsStatuses);
                }
                return { ...row, alert_hours: value }
            },
            renderEditCell: (params) => (
                <GridEditInputCell
                    {...params}
                    inputProps={{
                        min: 0,
                    }}
                />
            ),
        },
        {
            field: 'customer_communication',
            headerName: 'Alert Customer',
            type: 'boolean',
            minWidth: 100,
            flex: 1,
            editable: true,
            sortable: false,
            filterable: false,
            valueSetter: (value, row) => {
                if (myServiceOrderPartsStatuses[row.id]?.customer_communication !== value && row.id) {
                    const updatedMyServiceOrderPartsStatuses = { ...myServiceOrderPartsStatuses }
                    updatedMyServiceOrderPartsStatuses[row.id].customer_communication = value
                    setMyServiceOrderPartsStatuses(updatedMyServiceOrderPartsStatuses);
                }
                return { ...row, customer_communication: value }
            }
        },
        {
            field: 'alert_tech',
            headerName: 'Alert Tech',
            type: 'boolean',
            minWidth: 80,
            flex: 1,
            editable: true,
            sortable: false,
            filterable: false,
            valueSetter: (value, row) => {
                if (myServiceOrderPartsStatuses[row.id]?.alert_tech !== value && row.id) {
                    const updatedMyServiceOrderPartsStatuses = { ...myServiceOrderPartsStatuses }
                    updatedMyServiceOrderPartsStatuses[row.id].alert_tech = value
                    setMyServiceOrderPartsStatuses(updatedMyServiceOrderPartsStatuses);
                }
                return { ...row, alert_tech: value }
            }
        },
        {
            field: 'alert_manager',
            headerName: 'Alert Manager',
            type: 'boolean',
            minWidth: 80,
            flex: 1,
            editable: true,
            sortable: false,
            filterable: false,
            valueSetter: (value, row) => {
                if (myServiceOrderPartsStatuses[row.id]?.alert_manager !== value && row.id) {
                    const updatedMyServiceOrderPartsStatuses = { ...myServiceOrderPartsStatuses }
                    updatedMyServiceOrderPartsStatuses[row.id].alert_manager = value
                    setMyServiceOrderPartsStatuses(updatedMyServiceOrderPartsStatuses);
                }
                return { ...row, alert_manager: value }
            }
        },
        {
            field: 'alert_writer',
            headerName: 'Alert Writer',
            type: 'boolean',
            minWidth: 80,
            flex: 1,
            editable: true,
            sortable: false,
            filterable: false,
            valueSetter: (value, row) => {
                if (myServiceOrderPartsStatuses[row.id]?.alert_writer !== value && row.id) {
                    const updatedMyServiceOrderPartsStatuses = { ...myServiceOrderPartsStatuses }
                    updatedMyServiceOrderPartsStatuses[row.id].alert_writer = value
                    setMyServiceOrderPartsStatuses(updatedMyServiceOrderPartsStatuses);
                }
                return { ...row, alert_writer: value }
            }
        },
        {
            field: 'alert_part_specialist',
            headerName: 'Alert Part Specialist',
            type: 'boolean',
            minWidth: 80,
            flex: 1,
            editable: true,
            sortable: false,
            filterable: false,
            valueSetter: (value, row) => {
                if (myServiceOrderPartsStatuses[row.id]?.alert_part_specialist !== value && row.id) {
                    const updatedMyServiceOrderPartsStatuses = { ...myServiceOrderPartsStatuses }
                    updatedMyServiceOrderPartsStatuses[row.id].alert_part_specialist = value
                    setMyServiceOrderPartsStatuses(updatedMyServiceOrderPartsStatuses);
                }
                return { ...row, alert_part_specialist: value }
            }
        },
        {
            field: 'type',
            headerName: 'Status Type',
            minWidth: 160,
            flex: 1,
            editable: true,
            sortable: false,
            filterable: false,
            type: 'singleSelect',
            valueOptions: ({ row }) => row.id === '<<NEWSTATUS>>' ? SERVICE_ORDER_PART_STATUS_TYPES.filter((x) => !['CREATED', 'INSTALLED', 'DECLINED'].includes(x)) : [row.type],
            valueSetter: (value, row) => {
                if (myServiceOrderPartsStatuses[row.id]?.type !== value && row.id) {
                    const updatedmyServiceOrderPartsStatuses = { ...myServiceOrderPartsStatuses }
                    updatedmyServiceOrderPartsStatuses[row.id].type = value
                    setMyServiceOrderPartsStatuses(updatedmyServiceOrderPartsStatuses);
                }
                return { ...row, type: value }
            }
        },
        {
            field: 'custom_color',
            headerName: 'Color',
            width: 140,
            editable: true,
            sortable: false,
            filterable: false,
            type: 'string',
            renderCell: (params) =>
                <MuiColorInput
                    format="hex"
                    value={myServiceOrderPartsStatuses[params.row.id].custom_color}
                    disabled
                    sx={{ border: 0 }}
                    isAlphaHidden
                    variant="standard"
                />,
            renderEditCell: (params) =>
                <MuiColorInput
                    format="hex"
                    value={myServiceOrderPartsStatuses[params.row.id].custom_color}
                    onChange={(value) => {
                        const updatedmyServiceOrderPartsStatuses = { ...myServiceOrderPartsStatuses }
                        updatedmyServiceOrderPartsStatuses[params.row.id].custom_color = value
                        setMyServiceOrderPartsStatuses(updatedmyServiceOrderPartsStatuses);
                    }}
                    isAlphaHidden
                    variant="standard"
                />
        },
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Actions',
            width: 175,
            cellClassName: 'actions',
            getActions: ({ id, row }) => {
                const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
                const anyInEditMode = Object.values(rowModesModel).some((x) => { return x.mode === GridRowModes.Edit })
                const max_order_of_type = Object.values(myServiceOrderPartsStatuses).filter((x) => x.type === row.type).map((x => x.order)).reduce((a, b) => Math.max(a, b), 0) // get the max order of the current type

                if (isInEditMode) {
                    return [
                        <GridActionsCellItem
                            icon={<SaveIcon />}
                            label="Save"
                            sx={{
                                color: 'primary.main',
                            }}
                            onClick={handleSaveClick(id)}
                        />,
                        <GridActionsCellItem
                            icon={<CancelIcon />}
                            label="Cancel"
                            className="textPrimary"
                            onClick={handleCancelClick(id)}
                            color="inherit"
                        />,
                    ];
                }

                return [
                    <GridActionsCellItem
                        icon={<EditIcon />}
                        label="Edit"
                        className="textPrimary"
                        onClick={handleEditClick(id)}
                        color="inherit"
                        disabled={anyInEditMode}
                    />,
                    <GridActionsCellItem
                        icon={<DeleteIcon color="error" />}
                        label="Delete"
                        onClick={handleDeleteClick(id)}
                        color="inherit"
                        disabled={anyInEditMode || ['CREATED', 'INSTALLED', 'DECLINED'].includes(row.type)}
                    />,
                    <GridActionsCellItem
                        icon={<KeyboardArrowUpIcon />}
                        label="Move Up"
                        onClick={handleReorderClick(id, 'down')} // direction is the opposite of what you would expect
                        color="inherit"
                        disabled={anyInEditMode || row.order === 0}
                    />,
                    <GridActionsCellItem
                        icon={<KeyboardArrowDownIcon />}
                        label="Move Down"
                        onClick={handleReorderClick(id, 'up')} // direction is the opposite of what you would expect
                        color="inherit"
                        disabled={anyInEditMode || row.order === max_order_of_type}
                    />,
                ];
            },
        },
    ];



    const resetMyServiceOrderPartsStatuses = () => {
        const updated_service_order_parts_statuses = { ...(structuredClone(service_order_parts_statuses ?? {})) }
        Object.keys(updated_service_order_parts_statuses).forEach((key) => {
            updated_service_order_parts_statuses[key].id = key
            updated_service_order_parts_statuses[key].name = key
        })
        setMyServiceOrderPartsStatuses(updated_service_order_parts_statuses)
        order_rows(updated_service_order_parts_statuses)
    }

    const order_rows = (updated_service_order_parts_statuses) => {
        const sorted_rows = sort_custom_statuses(updated_service_order_parts_statuses).map((s) => updated_service_order_parts_statuses[s])
        setSortedRows(sorted_rows)
    }

    React.useEffect(() => {
        resetMyServiceOrderPartsStatuses()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [service_order_parts_statuses])

    return (
        <Box
            sx={{
                width: '100%',
                '& .actions': {
                    color: 'text.secondary',
                },
                '& .textPrimary': {
                    color: 'text.primary',
                },
            }}
        >
            <p><b>Service Order Part Statuses</b></p>
            <DataGrid
                rows={sortedRows}
                columns={columns}
                editMode="row"
                rowModesModel={rowModesModel}
                onRowModesModelChange={handleRowModesModelChange}
                onRowEditStop={handleRowEditStop}
                processRowUpdate={processRowUpdate}
                isCellEditable={(params) => !(params.row.id !== '<<NEWSTATUS>>' && ['type'].includes(params.field))}
                slots={{
                    toolbar: EditToolbar,
                }}
                slotProps={{
                    toolbar: { myServiceOrderPartsStatuses, setMyServiceOrderPartsStatuses, setRowModesModel, order_rows },
                }}
                disableColumnMenu
                hideFooter
            />
        </Box>
    );
}